import { string, object, ref } from "yup";

const passwordsSchema = object().shape({
  password: string().required("Champs vide"),
  confirmPassword: string()
    .oneOf([ref('password')], "Les deux champs doivent être identiques")
    .required("Champs vide")
});

export default passwordsSchema;
